const unsubPage = document.getElementById('unsubscribeForm');

if (unsubPage) {
    $(document).ready(() => {
        function getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
                var results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
        let memguid = getParameterByName('Member');
        memguid =
            'https://fogodechao.fbmta.com/members/UpdateProfile.aspx?_Theme=21474836688&Member=' +
            memguid;
        $('#unsublink').attr('src', memguid);
    });
}
